import { Alert, Box, Button, Dialog, DialogActions, Snackbar } from "@mui/material";
import useCreateUserMutation from "hooks/mutations/useCreateUserMutation";
import { useGetUsers } from "hooks/queries/useGetUsers";
import { useMultiStepForm } from "hooks/useMultiStepForm";
import { useSnackbar } from "hooks/useSnackbar";
import { useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import EmployeeDetails from "./EmployeeDetails";
import EmployeeImage from "./EmployeeImage";
import EmployeeRoles from "./EmployeeRoles";
import { Transition } from "./FormTransition";

interface AddEmployeeFormProps {
  employeeFormOpen: boolean;
  handleCloseEmployeeAddForm: () => void;
}

const AddEmployeeForm = ({
  employeeFormOpen,
  handleCloseEmployeeAddForm,
}: AddEmployeeFormProps) => {
  const methods = useForm();

  const [selectedDepartment, setSelectedDepartment] = useState<number | string>();
  const { users, isLoading, isFetching } = useGetUsers();

  const lineManagersInSelectedDepartment = users?.filter(
    (user) => user.department.id === selectedDepartment
  );

  const { steps, currentStepIndex, step, isFirstStep, isLastStep, goTo, back, next } =
    useMultiStepForm([
      <EmployeeRoles
        selectedDepartment={selectedDepartment}
        setSelectedDepartment={setSelectedDepartment}
        lineManagerOption={lineManagersInSelectedDepartment}
        loadingLineManagers={isLoading || isFetching}
      />,
      <EmployeeDetails />,
      <EmployeeImage />,
    ]);

  const { showSnackbar, getSnackbarProps } = useSnackbar();

  const { refetch } = useGetUsers();
  const { mutate: createNewUser } = useCreateUserMutation({
    callback: () => refetch(),
    showSnackbar,
  });

  const createUser = methods.handleSubmit(async (payload) => {
    console.log("Form Data Before Submit:", payload);
    createNewUser({ payload });
    handleCloseEmployeeAddForm();
    methods.reset();
    goTo(0);
  });

  return (
    <>
      <Dialog
        open={employeeFormOpen}
        onClose={handleCloseEmployeeAddForm}
        TransitionComponent={Transition}
        keepMounted
        maxWidth="sm"
        fullWidth
        aria-describedby="alert-dialog-slide-description"
      >
        <Box sx={{ position: "relative", padding: "20px" }}>
          <FormProvider {...methods}>
            <form encType="multipart/form-data" onSubmit={createUser}>
              <Box style={{ position: "absolute", top: "0.5rem", right: "0.5rem" }}>
                {currentStepIndex + 1} / {steps.length}
              </Box>
              {step}
            </form>
          </FormProvider>
        </Box>
        <DialogActions>
          {!isFirstStep && (
            <Button variant="outlined" type="submit" onClick={back}>
              Back
            </Button>
          )}
          <Button variant="contained" type="submit" onClick={isLastStep ? createUser : next}>
            {isLastStep ? "Finish" : "Next"}
          </Button>
        </DialogActions>
      </Dialog>
      <Snackbar
        {...getSnackbarProps()}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        autoHideDuration={4000}
      >
        <Alert {...getSnackbarProps()}>{getSnackbarProps().message}</Alert>
      </Snackbar>
    </>
  );
};
export default AddEmployeeForm;
